import {useTranslation} from '@aboutyou/i18n';

export const useCustomerServiceTranslations = () => {
  const {t} = useTranslation();

  return {
    chat_with_us: t('Chat with us'),
    get_instant_help: t(
      'Get 24/7 help from our Chatbot and avoid waiting times.',
    ),
    start_chat: t('Start Chat'),
    give_us_a_call: t('Give us a call'),
  };
};
